module.exports = __webpack_public_path__ + "static/GorditaBold-ae04b3e514aa05f29151842ac2580a56.otf";